module.exports = __webpack_public_path__ + "media/images/lb/898-98645ba450f86367d9ee6854e30155b4.svg";